import React from 'react';

class CupsPrinter extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;
    let kioskInfo = hostInfo.kioskInfo || {};
    let cups = kioskInfo.cups || {};
    let printers = cups.printer || [];

    // console.log(cups);
    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>CUPS Printer</div>
        </div>

        <div className='info-card pure-u-4-24'>
          <span>Pending Print Jobs:</span>
          <div style={{ color: hostInfo.cupsPendingPrintJobs > 1 ? 'red' : 'green' }}>
            {hostInfo.cupsPendingPrintJobs}
          </div>
        </div>
        <div className='info-card pure-u-8-24'>
          <span>Default Printer:</span>
          <div>{cups.defaultPrinter}</div>
        </div>
        <div className='info-card pure-u-12-24'>
          <span>Printers:</span>
          <div style={{ fontWeight: 500 }}>
            {printers.map((p) => (
              <div key={p}>{p}</div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CupsPrinter;



// WEBPACK FOOTER //
// ./src/components/CupsPrinter.js